import React, { PropsWithChildren } from 'react'

import * as S from './styles'

export type TagProps = PropsWithChildren<{
  /**
   * The label of the Tag
   *
   * @example
   * ```tsx
   * <Tag label="my-class" />
   * ```
   *
   */
  label: string

  /**
   * State of the Tag
   *
   * @default false
   * @example
   * ```tsx
   * <Tag selected={true} />
   * ```
   *
   */
  selected?: boolean

  /**
   * Function to be called when the tag is clicked
   *
   * @example
   * ```tsx
   * <Tag onClick={() => console.log('Text clicked')} />
   * ```
   *
   */
  onClick?: () => void
}>

export const Tag: React.FC<TagProps> = ({
  label,
  onClick,
  selected = false,
}) => (
  <S.Button selected={selected} onClick={onClick}>
    {label}
  </S.Button>
)
